import { useParams, useSearchParams } from 'react-router-dom';
import useCustomNavigate from '../../core/hooks/router/useCustomNavigate';
import parseNumberFromQueryParam from '../../core/util/parseNumberFromQueryParam';

const usePagination = () => {
    const [searchParams] = useSearchParams();

    const { categoryId } = useParams<{ categoryId: string }>();
    const navigate = useCustomNavigate();
    const { page: pageString } = useParams<{
        page?: string;
    }>();

    const page = parseNumberFromQueryParam(pageString) || 1;

    const navigateToPage = (newPage: number, newSearch: string) => {
        if (categoryId) {
            navigate(
                `../categories/${categoryId}/page/${newPage}?${newSearch}`,
                {
                    preventScrollReset: true,
                }
            );
            return;
        }
        navigate(`../page/${newPage}?${newSearch}`, {
            preventScrollReset: true,
        });
    };

    const updatePage = (newPage: number) => {
        if (page !== newPage) {
            navigateToPage(newPage, searchParams.toString());
        }
    };

    return { page, updatePage, navigateToPage };
};

export default usePagination;
